export const QuoteCardTitle: React.FC<{
  tierText: "Plus" | "Integral" | "Plus / Integral";
  licenseText: string;
}> = ({ tierText, licenseText }) => (
  <h4 className="mb-2 flex flex-col gap-1 text-lg font-bold sm:flex-row sm:gap-4">
    <strong>
      Delta<span className="font-normal">Math</span>{" "}
      <span className="uppercase">{tierText}</span>
    </strong>
    <span className="font-normal text-dm-gray-500">{licenseText}</span>
  </h4>
);
